module.exports = __webpack_public_path__ + "img/k3.7e4d0866.png";